import { createSelector } from 'reselect';
import { getGameStaticData } from '@gameday/utils/selectors/getGameStaticData';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { DEFAULTS } from '@gameday/utils/languageHelpers';

const gameStatusMap = {
    preview: 'P',
    live: 'L',
    final: 'F'
};

const getGameContext = (state) => state.gameContext;
const getGamedayContext = (state) => state.config?.context?.gameContext;
const getLanguage = (state) => state.config?.language || DEFAULTS.language;
const geGameView = (state) => state.views?.game_view;
const getTimezone = (state) => state.config?.timezone;
const getHomeAwayContext = (state) => {
    const teamContextId = state.config?.teamId;
    const homeTeamId = state.gameContext?.gameDetailInfo?.teams?.home?.id;
    return teamContextId === homeTeamId ? 'home' : 'away';
};

export const getGameContextState = createSelector(
    [getGameContext, getGameStaticData, getGamedayContext, getLanguage, geGameView, getTimezone, getHomeAwayContext],
    (gameContext, gameStaticData, gamedayContext, language, gameView, timezone, homeAwayContext) => {
        let formattedDate;
        let { gameState } = gameContext;

        if (gameStaticData?.datetime.dateTime) {
            formattedDate = format(utcToZonedTime(gameStaticData?.datetime.dateTime, timezone), 'yyyyMMdd');
        }

        const gameViewByGameState = !!(gameView && gameStatusMap[gameView.toLowerCase()]);
        gameState = gameViewByGameState ? gameStatusMap[gameView.toLowerCase()] : gameState || 'P';

        return {
            ...gameContext,
            gamePk: gameStaticData.pk,
            gameDate: formattedDate,
            language,
            gamedayContext,
            gameState,
            timezone,
            homeAwayContext
        };
    }
);
